import { proxy } from 'valtio';
interface IAccountStore {
    affiliates: [],
    affiliateSelected: string
}
class AccountStore {

    state = proxy<IAccountStore>({
          affiliates: [],
          affiliateSelected: ""
        });
}

export const accountState = proxy(new AccountStore());